import React from 'react'
import parse from 'html-react-parser'
import { splitFill } from '../../utils'

export function Response({ responses, id }) {
  return (
    <>
      <h3 id={id}>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>Field</th>
            <th>Type</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {responses.map(response => (
            <tr key={response.field}>
              <td>
                {parse(splitFill(response.field))}
                {response.optional && <sub className='label-optional'>optional</sub>}
              </td>
              <td>{response.type}</td>
              <td>
                <div>{parse(response.description)}</div>
                {response.allowedValues && (
                  <>
                    <span style={{ marginRight: 10 }}>Allowed values:</span>
                    {response.allowedValues.map((tag, i) => (
                      <React.Fragment key={i}>
                        <code>{tag}</code>,
                      </React.Fragment>
                    ))}
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}
